"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryParse = void 0;
function tryParse(data) {
    if (typeof data === 'string') {
        try {
            return JSON.parse(data);
        }
        catch (e) {
            /* Ignore */
        }
    }
    return data;
}
exports.tryParse = tryParse;
//# sourceMappingURL=experiments-data-utils.js.map